module.exports = __webpack_public_path__ + "assets/bell-inactive-hover.e6535927.svg";